module.exports = BMAP_STATUS_SUCCESS;


//////////////////
// WEBPACK FOOTER
// external "BMAP_STATUS_SUCCESS"
// module id = vU1t
// module chunks = 38